import React, { useEffect } from 'react';

import { useAppDispatch, useOverlayState, useProfileData } from '../../../hooks';
import { set } from '../../../store/overlay';
import { cn, resultIf } from '../../../utils';

import './Overlay.scoped.scss';

const Overlay = () => {
  const dispatch = useAppDispatch();
  const isOverlayActive = useOverlayState();
  const profileData = useProfileData();

  const closeOverlay = () => {
    if (!profileData.lenderVerified || isOverlayActive) {
      return;
    }
    dispatch(set(false));
  };

  useEffect(() => {
    const callback = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeOverlay();
      }
    };
    window.addEventListener('keyup', callback);
    return () => {
      window.removeEventListener('keyup', callback);
    };
  }, [profileData.lenderVerified]);

  return (
    <>
      <div
        id="overlay"
        className={cn(resultIf(isOverlayActive, 'active'))}
        onClick={closeOverlay}
      />
    </>
  );
};

export default Overlay;
